var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql, useQuery } from '@apollo/client';
var TEAM_NAME = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query TeamName($id: ID!) {\n    team(id: $id) {\n      id\n      name\n    }\n  }\n"], ["\n  query TeamName($id: ID!) {\n    team(id: $id) {\n      id\n      name\n    }\n  }\n"])));
export var useTeamNameQuery = function (options) { return useQuery(TEAM_NAME, options); };
export default TEAM_NAME;
var templateObject_1;
